import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MgsFieldDefaultComponent } from './mgs-field-default.component';
import { NgStyle } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'mng-mgs-field-boolean-component-name',
  imports: [NgStyle, MatCheckbox, ReactiveFormsModule],
  template: `
    <mat-checkbox
      [ngStyle]="style"
      color="accent"
      [attr.id]="defId"
      [formControl]="formControl"
      labelPosition="after"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MgsFieldBooleanComponent extends MgsFieldDefaultComponent {
  constructor() {
    super();
  }
}
